//@ts-ignore
import Vue from 'vue/dist/vue.esm'

import hotelRoomStore from './library/js/store/hotel-rooms.store'

import HotelFilterWidget from "./library/js/components/hotel/hotelFilterWidget.vue";
import PageListRoom from "./library/js/components/hotel/pageListRoom.vue";
import HotelRoomDetails from "./library/js/components/hotel/hotelRoomDetails.vue";
import Loader from "./library/js/components/loader.vue";

interface ReservationWidgetDatesCache {
  exp: number;
  checkin: string;
  checkout: string;
  code: string;
  iata: string;
}

Vue.component('hotel-filter-widget', HotelFilterWidget);
Vue.component('page-list-room', PageListRoom);
Vue.component('hotel-room-details', HotelRoomDetails);
Vue.component('loader', Loader);

let saveResDataTimer = -1;

window.hotelRoomsVueApp = new Vue({
    store: hotelRoomStore,
    mounted: function () {
        $(window.resetPageLinks);
    },
    methods: {
        formatDateObjectYYYYMMDD: function (dateObject: Date) {
            let regMatch;

            // check for valid date
            if (typeof dateObject === 'object' && typeof dateObject.getMonth === 'function') {
                regMatch = /(20\d{2})-(\d{1,2})-(\d{1,2})/.exec(dateObject.getFullYear() + '-' + (dateObject.getMonth() + 1) + '-' + dateObject.getDate());

                if (!!regMatch) {
                    // verify correct format for months
                    if (regMatch[2].length < 2) regMatch[2] = '0' + regMatch[2];

                    // verify correct format for days
                    if (regMatch[3].length < 2) regMatch[3] = '0' + regMatch[3];

                    return regMatch[1] + '-' + regMatch[2] + '-' + regMatch[3];
                }
            }

            return '';
        },
        formatYYYYMMDDToDateObject: function (YYYYMMDD: string) {
            let matches = /(\d{4})-(\d{2})-(\d{2})/.exec(YYYYMMDD);
            if (matches) {
                let date = new Date();
                date.setFullYear(parseInt(matches[1], 10));
                date.setMonth(parseInt(matches[2], 10) - 1);
                date.setDate(parseInt(matches[3], 10));

                return date;
            }

            return null;
        },
        daysBetween: function (startDate: Date, endDate: Date) {
            let millisecondsPerDay = 24 * 60 * 60 * 1000;

            return (window.pepDateFunctions.treatAsUTC(endDate).getTime() - window.pepDateFunctions.treatAsUTC(startDate).getTime()) / millisecondsPerDay;
        },
        addDays: function (date: Date, days: number) {
            let result = new Date(date);

            result.setDate(result.getDate() + days);

            return result;
        },
        addMonths: function (date: Date, months: number) {
            let result = new Date(date);

            result.setMonth(result.getMonth() + months);

            return result;
        },

        getReservationSelections: function () {
            let output = {};

            if ('JSON' in window) {
                //check for saved values for check in/out dates
                try {
                    const cacheData: {DATA: ReservationWidgetDatesCache} | null = window.pepHelperFunctions.getCachedData('reservation-widget-dates', 1800000, true) || null;
                    if (cacheData) {
                        //make sure check-in-out dates are valid
                        if (cacheData.DATA.checkin) {
                            let checkIn = new Date(cacheData.DATA.checkin as string);
                            const checkInSave = checkIn;
                            let checkInString = window.pepDateFunctions.formatDateObjectYYYYMMDD(checkIn);
                            const todayDate = new Date();
                            const todayString = window.pepDateFunctions.formatDateObjectYYYYMMDD(todayDate);
                            if (checkInString < todayString) {
                                cacheData.DATA.checkin = todayDate.toString();
                                checkIn = todayDate;
                                checkInString = window.pepDateFunctions.formatDateObjectYYYYMMDD(checkIn);
                                // console.log('change checkIn', checkIn, checkInString);
                            }

                            if ('checkout' in cacheData.DATA) {
                                const checkOut = new Date(cacheData.DATA.checkout as string);
                                const checkOutString = window.pepDateFunctions.formatDateObjectYYYYMMDD(checkOut);
                                if (checkInString >= checkOutString) {
                                    const daysBetween = window.pepDateFunctions.daysBetween(checkInSave, checkOut);
                                    cacheData.DATA.checkout = window.pepDateFunctions.addDays(checkIn, daysBetween).toString();
                                }
                            }
                        }
                        output = cacheData.DATA;
                    }
                } catch (e) {
                    console.log(e);
                }
            }

            return output;
        },
        saveReservationSelections: function ($widgetEle: JQuery<Element>, checkInDate: Date, checkOutDate: Date, overrides = {checkin: null, checkout: null, code: null, iata: null, timerDuration: 33}) {
            if ($widgetEle.data('initialized') && 'JSON' in window) {
                window.clearTimeout(saveResDataTimer);
                saveResDataTimer = window.setTimeout(function () {
                    try {
                        let $inputs = $widgetEle.find('.pepvalidate-v3').find('input, select');
                        window.pepHelperFunctions.setCachedData(
                            'reservation-widget-dates',
                            {
                                exp: window.pepDateFunctions.addMinutes(new Date(), 30),
                                checkin: overrides.checkin ? overrides.checkin : checkInDate.toJSON(),
                                checkout: overrides.checkout || checkOutDate.toJSON(),
                                code: overrides.code || $inputs.filter('[name=offer_code]').val(),
                                iata: overrides.iata || $inputs.filter('[name=iata]').val()
                            },
                            true
                        );
                    } catch (e) {
                        console.log(e);
                    }
                }, overrides.timerDuration);
            }
        },

        formatAsDollarAmount: function (amount: string | number, truncate: boolean = true) {
            let tmp = [];
            try {
                let formattedAmount = amount;
                if (typeof formattedAmount === 'string') {
                    formattedAmount = formattedAmount.replace(/[$,]/g, '');
                    formattedAmount = parseFloat(formattedAmount);
                }

                // @ts-ignore
                if (truncate && formattedAmount.toFixed(2) == parseInt(formattedAmount, 10)) {
                    formattedAmount = parseInt('' + formattedAmount, 10);
                } else {
                    formattedAmount = formattedAmount.toFixed(2);
                }

                formattedAmount = '' + formattedAmount;

                if (formattedAmount.indexOf('.') > -1) {
                    tmp = formattedAmount.split('.');
                } else {
                    tmp[0] = formattedAmount;
                }

                tmp[0] = tmp[0].replace(/([0-9])(?=([0-9]{3})+)/g, '$1,');

                formattedAmount = tmp.join('.');

                return formattedAmount;
            } catch (e) {
                return amount;
            }
        }
    }
})
    .$mount("#container");